// extracted by mini-css-extract-plugin
export default {"containprod":"IH","containprod2":"JH","title":"KH","servings":"LH","recommendation":"MH","image":"NH","flavorswrap":"OH","flavorsgroupwrap":"PH","moredetailsWrap":"QH","infoWrap":"RH","price":"SH","regularPrice":"TH","netPrice":"UH","addtocartcontainer":"VH","error":"WH"};
    if(module.hot) {
      // 1711394578666
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  